import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as validate from '../Modals/validations.js';
import { getBuildingData,getSelectedTabstate, GlobalZipUpdate, handleCompanySelection, handleStateManufactureChange, savePriceComparisionDataForNotLoggedIn, setZipCodeVal } from "../../action/index.js";
import { stateManufacturerChange } from "../../action/manufacturers_auth/manufacture.action.js";
import {getManufactureDetails } from "../../action/manufacturers_auth/login.action.js";
import { setDefaultValuesOnSalesLoginBtnClick, sortArrayStrings } from "../../redux/reducers/utils.js";
import ZipDropDown from "./ZipDropDown.js";
import { Select } from "@rmwc/select";
import { const_var } from "../../redux/reducers/reducer.js";
import { handleAccordionTab } from "../../action/building/building_style/buildingStyle.action.js";
import { onResize } from "../../redux/reducers/building_component/componentReducer.js";
import { getDealerStateList } from "../../action/manufacturers_auth/manufacture.action.js";

const ZipcodeTooltip = ({
  isShowZipTooltip,
  setShowTooltip,
}) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer);

    const zipTooltipRef = useRef(null);
    const [showStateInLocal, setShowStateInLocal] = useState([]);
    const [showState, setShowState] = useState(false);
    // const [showManufacturerFields, setShowManufacturerFields] = useState(true);
    const [selectedState, setSelectedState] = useState(state.params.p_s_n);
    const [selectedManufacture, setSelectedManufacture] = useState(state.params.m_s_n);
    const [selectedZipCode, setSelectedZipCode] = useState(state.const_var.state_mfg_zipcode)
    const [setZipCode, setSetZipCode] = useState(state.const_var.state_mfg_zipcode);

    const [manufactureDropdown, setManufactureDropdown] = useState([])
    const isZipScreenEnable = state.const_var.crmSetting.is_zipcode_screen != undefined && state.const_var.crmSetting.is_zipcode_screen == true ?  true : false  
    
    let showStateSel = false;

    const getSelectTempWidth = (text) => {
        var test = document.createElement("span");
        test.style.fontSize = '12px';
        test.style.fontWeight = 500;
        test.textContent = text;
        document.body.appendChild(test);
        const width = (test.getBoundingClientRect().width>0)?test.getBoundingClientRect().width + 22:170;
        document.body.removeChild(test);
        return width;
    }

    const getSelectedManufacturerLabel = () => {
        if(!const_var.zipcodeToolTipDataFlag){
            return state.const_var.stateManufacturerAcordingAPI[selectedState]?.find((item, index) => item.id === selectedManufacture)?.name;
        }else{
            if(Object.keys(const_var.zipcodeToolTipData).length>0){    
                return const_var.zipcodeToolTipData.data[0].manufacturer_list?.find((item, index) => item.id === selectedManufacture)?.name;
            }
        }
    }
    const getSelectedStateLabel = () => {
        //state.const_var.bjD.find((item, index) => {console.log(item)})
        return state.const_var.bjD.find((item, index) => (item!=undefined)?item.id === selectedState:'')?.name;
    }

    
    if(isZipScreenEnable == true && state.const_var.showStateFieldInToolTip == true  && ((state.const_var.showStateZip != undefined && state.const_var.showStateZip == true) || (state.const_var.is_State_Edit != undefined && state.const_var.is_State_Edit == true && state.const_var.hodldEditBuildingData != undefined && (state.const_var.hodldEditBuildingData == undefined || state.const_var.hodldEditBuildingData.state_mfg_zipcode == '' || state.const_var.hodldEditBuildingData.state_mfg_zipcode == null)))){
        showStateSel = true
    }

    useEffect(()=>{
        if(state.params.m_s_n != undefined && state.params.m_s_n != selectedManufacture){
            setSelectedManufacture(state.params.m_s_n)
        }
        if(state.params.p_s_n != undefined && state.params.p_s_n != selectedState){
            setSelectedState(state.params.p_s_n)
        }
    },[state.params.m_s_n,state.params.p_s_n])


    // useEffect(()=>{

    useEffect(()=>{
        if(state.const_var.displayerrorMessage.company_id){
            let element = document.getElementsByTagName('body')[0]
            element.classList.add('full-screen-overlay')
        }
        else{
            let element = document.getElementsByTagName('body')[0]
            if(element && element.classList.contains('full-screen-overlay')){
                element.classList.remove('full-screen-overlay')
            }
        }
    },[state.const_var.displayerrorMessage.company_id])
    const confirmChange=()=>{
        const removea = document.querySelector('body');
        state.isfullviewbuilding = false
        removea.classList.remove("active-fullview");
        onResize()

        if((isZipScreenEnable != true && (state.const_var.confirmState == true || state.const_var.crmSetting.pre_quote_form == true)) || (isZipScreenEnable == true)){
      
            if (callApifun === false) {
               dispatch(getSelectedTabstate("buildingtypetab"));
               setShowTooltip(!isShowZipTooltip);                      
            } else {
                if(isZipScreenEnable && (const_var.state_mfg_zipcode_old != selectedZipCode || selectedManufacture != state.params.m_s_n ||  selectedState != state.params.p_s_n)){
                    document.querySelector('body').classList.add('active-modal-loader');
                    if(Object.keys(const_var.zipcodeToolTipData).length>0){ 
                        dispatch({
                            type:"setDealerStateList",
                            value : const_var.zipcodeToolTipData
                        });
                     }
                    setStateSel(selectedState, "state");
                    const_var.state_mfg_zipcode_old = selectedZipCode;
                    if(state.const_var.loginSession == true) {
                        dispatch(stateManufacturerChange(selectedManufacture, "manufacturer"))
                    }
                    handleBtnClick(); 
                 }
                 if(!isZipScreenEnable){
                    document.querySelector('body').classList.add('active-modal-loader');
                    if(Object.keys(const_var.zipcodeToolTipData).length>0){ 
                        dispatch({
                            type:"setDealerStateList",
                            value : const_var.zipcodeToolTipData
                        });
                     }
                    const_var.isCompanyIdChanged = false;
                    setStateSel(selectedState, "state");
                    if(state.const_var.loginSession == true) {
                        dispatch(stateManufacturerChange(selectedManufacture, "manufacturer"))
                    }
                    handleBtnClick(); 
                 }
                 setShowTooltip(!isShowZipTooltip);   
                 const_var.isFromPickThis = false;                     
            }
            dispatch(handleAccordionTab("","buildingtypetab","reset"))
        }
    }

    useEffect(() => {
        if(state.const_var.stateManufacturerAcordingAPI != undefined && state.const_var.stateManufacturerAcordingAPI[selectedState] != undefined && state.const_var.loginSession == true && state.const_var.isKLinkEnable == false && !state.const_var.isFromCompare) {
            
          if(state.const_var.stateManufacturerAcordingAPI[selectedState]!=undefined && state.const_var.stateManufacturerAcordingAPI[selectedState].length>0){
            let manuData =  state.const_var.stateManufacturerAcordingAPI[selectedState].map((val, index) => {
                 return {
                     value: val.id,
                     label: val.name,
                 };
             })
             setManufactureDropdown(manuData)
          }

        }
    },[selectedState,state.const_var.stateManufacturerAcordingAPI != undefined && state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n], state.const_var.zipCode, state.const_var.state_mfg_zipcode,selectedZipCode])
    useEffect(() => {
            if(Object.keys(const_var.zipcodeToolTipData).length>0 && state.const_var.loginSession == true ){
                let manufacData = const_var.zipcodeToolTipData.data.find(item => item.id == selectedState)
                if(manufacData!=undefined && manufacData?.manufacturer_list.length>0){
                    let manuData = manufacData?.manufacturer_list.map(val => ({
                        value: val.id,
                        label: val.name
                    }));
                    setSelectedManufacture(manuData[0].value)
                    setManufactureDropdown(manuData)
                }
            }
    },[selectedState])

    const handleZipCode = (e) => {
        let zipCode = e.target.value;
        setSetZipCode(e.target.value)
        let numberRegex = /^\d+$/; 

        if(numberRegex.test(e.target.value) || e.target.value == "") {
            setSelectedZipCode(zipCode)
            // dispatch(setZipCodeVal(zipCode))  
            state.const_var.ziperrormsg = '';
            // state.const_var.displayerrorMessage = {};
            state.const_var.zipManufErrMsg = '';
            
            if(zipCode && zipCode.length <= 4) {
              validate.onTextFiledChangeValue(zipCode, 'zipcode', 'Zip Code');
            //   dispatch(setZipCodeVal(zipCode))
              showManufacturerFields = false;
              showStateSel = false;
            }
            if(zipCode && zipCode.length > 4 ){
                validate.onTextFiledChangeValue(zipCode, 'zipcode', 'Zip Code')             
            }
            if(zipCode.length == 5) {
                validate.onTextFiledChangeValue(e.target.value, 'zipcode', 'Zip Code')
                dispatch(setZipCodeVal(e.target.value)) 
                if(const_var.loginSession == false){
                  dispatch(GlobalZipUpdate(true))
                }
                dispatch(getDealerStateList(false, true, e.target.value,true))
                const_var.state_mfg_zipcodeHold = e.target.value
            }
        }
    }

    useEffect(() => {     

            if(Object.keys(const_var.zipcodeToolTipData).length>0 && const_var.zipcodeToolTipData.data.length>0){
                let stateData = const_var.zipcodeToolTipData.data?.map((val, index) => {
                    return {
                        value: val.id,
                        label: val.state_name,
                    };
                })
                setShowStateInLocal(stateData)
                setSelectedState(const_var.zipcodeToolTipData.data[0].id)
                if(const_var.loginSession == true && const_var.zipcodeToolTipData.data[0].manufacturer_list.length>0){
                    setSelectedManufacture(const_var.zipcodeToolTipData.data[0].manufacturer_list[0].id)
                    let manuData = const_var.zipcodeToolTipData.data[0].manufacturer_list?.map((val, index) => {
                        return {
                            value: val.id,
                            label: val.name,
                        };
                    })
                    setManufactureDropdown(manuData)
                }
            }
    
    },[const_var.zipcodeToolTipDataFlag,const_var.zipcodeToolTipData])

    const setZipInputValue=(zipCode)=>{
        let zip_code = (zipCode || zipCode == '') ? zipCode : state.const_var.state_mfg_zipcode
        const inputElements = [...document.querySelectorAll('input.zipInput')]
        if(zip_code != ''){
           const allzipvalue=  Array.from(String(zip_code), Number)
           // document.querySelector('.btn-go-zip')?.classList.remove('disabled')
            inputElements.forEach((ele,index)=>{ 
                if(allzipvalue[index]!=undefined)                       
                {
                    ele.value= allzipvalue[index];
                }
            })
            state.const_var.resetVal = false
        }
        else{
           // document.querySelector('.btn-go-zip')?.classList.remove('disabled')
            inputElements.forEach((ele,index)=>{ 
                 ele.value= '';
            })
            state.const_var.resetVal = false
        }
     }
     const salesLogin=()=>{
      dispatch(setZipCodeVal('', "statemanufacturechangepage"))
      setDefaultValuesOnSalesLoginBtnClick()
      dispatch(getSelectedTabstate("loginstyletab"))
   }
    const setStateSel = (val) => {
        if(state.const_var.crmSetting.is_zipcode_screen != undefined && state.const_var.crmSetting.is_zipcode_screen == true){
           setZipInputValue('');
           state.const_var.state_mfg_zipcode = '';
           state.const_var.tempZCode = '';
           state.const_var.ziperrormsg = '';
           state.const_var.displayerrorMessage = {}
           state.const_var.checkValidatePattern = false
        }
        dispatch(stateManufacturerChange(val, "state"))
    }

    const handleBtnClick = async() => {
        // const stateId = state.params.p_s_n;
        setSelectedState(state.params.p_s_n)
        const stateId = selectedState || state.params.p_s_n;
       
        const selectedStateData = state.const_var.bjDData?.find(state => state.id == stateId);
       
        if(selectedStateData && !state.const_var.loginSession && selectedStateData?.manufacturer_list?.price_comparision?.length > 0) {
           const key = `selectedState_${stateId}`;
           let mfgList = [selectedStateData?.manufacturer_list,...selectedStateData?.manufacturer_list?.price_comparision]
           dispatch(savePriceComparisionDataForNotLoggedIn(key,mfgList))
        //    dispatch(savePriceComparisionDataForNotLoggedIn(key,selectedStateData?.manufacturer_list?.price_comparision))
        }
        if(const_var.companyIdSelectedFromStateScreen != undefined) {
            const_var.companyIdSelectedFromStateScreen = state.params.company_id;
        }
        // dispatch(getBuildingData(state.params, 'direct'));
        dispatch(getManufactureDetails(state.params.manufactureKey,true));
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [])
    
    const handleOutsideClick = (event) => {
        const isShowDropdown = document.getElementsByClassName('showDropdown').length > 0
        let element = document.getElementsByTagName('body')[0]
        if(element && element.classList.contains('full-screen-overlay')) {
            return;
        }
        if(isShowDropdown)
            return;
        if (zipTooltipRef.current && !zipTooltipRef.current.contains(event.target) && document.querySelector("#statemanufacturetooltip") && !document.querySelector("#statemanufacturetooltip").contains(event.target)) {            
            setShowTooltip(false);
        }
    }

    let stateArr = []
    if(state.const_var.bjD != undefined && Object.keys(const_var.zipcodeToolTipData).length == 0 && state.const_var.bjD.length>0){
        state.const_var.bjD.forEach((val, index) => {
            if(val.name != "Select") {
                stateArr.push({ value: val.id, label: val.name });
            }
        })
        stateArr = stateArr.sort((a, b) => a.label.localeCompare(b.label))
        sortArrayStrings(stateArr,'name');
    }


    let callApifun = true;

    if(isZipScreenEnable == true) {
        if((selectedZipCode != '' && selectedZipCode == state.const_var.state_mfg_zipcode && selectedZipCode.length == 5 && selectedState==state.params.p_s_n && selectedManufacture == state.params.m_s_n && state.const_var.isGlobalZipUpdate == false) || (selectedZipCode == '' && selectedState==state.params.p_s_n && selectedManufacture == state.params.m_s_n && state.const_var.isGlobalZipUpdate == false) || (selectedZipCode.length < 5 && selectedState==state.params.p_s_n && selectedManufacture == state.params.m_s_n && state.const_var.isGlobalZipUpdate == false)) {
            // callApifun = false;
        }
        else {
            callApifun = true
        } 
    } else {
        if(selectedState==state.params.p_s_n){
            callApifun = false;
        }
        if(selectedManufacture!=state.params.m_s_n){
            callApifun = true;
        }
        if(const_var.isCompanyIdChanged == true) {
            callApifun = true;
        }
    }

    // ################ Variable used to show manufacturer dropdown ################
    let isUserData = localStorage.getItem('userData') ? true : false

    let showManufacturerFields = true;
    if (isZipScreenEnable == true) {
        if (
            (isUserData || state.const_var.loginSession == true) &&
            (
                (state.const_var.is_State_Edit != undefined && state.const_var.is_State_Edit == true && state.const_var.editAPIDataByResponse.data != undefined && state.const_var.editAPIDataByResponse.data.created_at > "2023-12-13") ||
                state.const_var.state_mfg_zipcode.length == 5 ||
                showStateSel == true
            )
        ) {
            showManufacturerFields = true;
        }
        else {
            showManufacturerFields = false;
        }

        if(const_var.loginSession == true) {
            showManufacturerFields = true
        }
    }
    if ((state.const_var.crmSetting.is_CRM == true && state.const_var.loginSession == true)) {
        showManufacturerFields = true;
    }
    if (state.const_var.crmSetting.is_CRM == false && state.const_var.loginSession == true) {
        showManufacturerFields = true;
    }
    if (state.const_var.crmSetting.is_CRM == false && state.const_var.loginSession == false && state.const_var.isZipcodeIncluded != undefined && state.const_var.isZipcodeIncluded == true) {
        showManufacturerFields = true;
    }
    if (showStateSel == true) {
        showManufacturerFields = true;
    }



   // ################ Variable used to manage design button active/disabled mode ################
   let isBtnDisabled = false;
   if (
      isZipScreenEnable == true && ((state.const_var.is_State_Edit == false || state.const_var.is_State_Edit == true) && showStateSel == false &&
            (
               (
                  state.const_var.state_mfg_zipcode == '' || 
                  state.const_var.state_mfg_zipcode.length != 5 || 
                  (state.const_var.ziperrormsg != '' && state.const_var.ziperrormsg != undefined) || 
                  (state.const_var.displayerrorMessage.zipcode != undefined && state.const_var.displayerrorMessage.zipcode != '') || 
                  state.const_var.SApiCalled == undefined || 
                  state.const_var.SApiCalled == false
               ) 
            ) 
         )
   ){
      isBtnDisabled = true;
   }
   if(
      (isZipScreenEnable == false || showStateSel == true) && 
      (state.params.p_s_n=="" || state.params.p_s_n==0) 
      && (state.params.m_s_n=="" || state.params.m_s_n==0)
   ){
      isBtnDisabled = true;
   }
   if(
      (isZipScreenEnable == true && state.const_var.state_mfg_zipcode!='' && state.const_var.state_mfg_zipcode.length != 5) || 
      (showStateSel == true && 
         (state.params.p_s_n=="" || state.params.p_s_n==0) && 
         (state.params.m_s_n=="" || state.params.m_s_n==0)
         )
         ){
      isBtnDisabled = true;
   }
   if(isZipScreenEnable == true && state.const_var.SApiCalled == true && state.const_var.isZipcodeIncluded != undefined && state.const_var.isZipcodeIncluded == false && state.const_var.showStateZip == false && state.const_var.crmSetting.is_CRM == true){
      isBtnDisabled = true;
   }
  


    const zipToolTipClose = () =>{
        setSelectedState(state.params.p_s_n);
        setSelectedManufacture(state.params.m_s_n);
        setSelectedZipCode(const_var.state_mfg_zipcode_old)
        const_var.zipcodeToolTipDataFlag = false
        const_var.zipcodeToolTipData = {}
        if(state.const_var.stateManufacturerAcordingAPI != undefined && state.const_var.stateManufacturerAcordingAPI[selectedState] != undefined && state.const_var.loginSession == true && state.const_var.isKLinkEnable == false && !const_var.zipcodeToolTipDataFlag) {
          if(state.const_var.stateManufacturerAcordingAPI[selectedState]!=undefined && state.const_var.stateManufacturerAcordingAPI[selectedState].length>0){
            let manuData =  state.const_var.stateManufacturerAcordingAPI[selectedState]?.map((val, index) => {
                 return {
                     value: val.id,
                     label: val.name,
                 };
             })
            setManufactureDropdown(manuData)
          }
          state.params.selectedManufactureId = state.params.m_s_n;
          setSelectedManufacture(state.params.selectedManufactureId);
        }
        if(state.const_var.state_mfg_zipcode_old != state.const_var.state_mfg_zipcode){
            state.const_var.showStateBoxInZipErr = state.const_var.showStateBoxInZipDefault;
            state.const_var.ziperrormsg = state.const_var.zipErrDefaultMessage
        }
        if(state.const_var.showStateBoxInZipErr){
            state.const_var.displayerrorMessage.zipcode = ""
        }
        const_var.state_mfg_zipcode = const_var.state_mfg_zipcode_old
        setSetZipCode(const_var.state_mfg_zipcode)
    }
    useEffect(()=>{
        zipToolTipClose()
        if(isShowZipTooltip == false && const_var.companyIdSelectedFromStateScreen != "" && state.params.company_id != '' && const_var.companyIdSelectedFromStateScreen != state.params.company_id)  {
            dispatch(handleCompanySelection(const_var.companyIdSelectedFromStateScreen, 'tooltip'))
        }
    },[isShowZipTooltip]);

    if(showStateInLocal.length>0 && const_var.zipcodeToolTipDataFlag ){
        stateArr = showStateInLocal
    }
    if(state.const_var.showStateBoxInZipErr){
        state.const_var.ziperrormsg = ""  
    }

    return (
        <>
        {    isShowZipTooltip &&
            <div className={`zip-tooltip ${state.const_var.loginSession && 'zip-tooltip-non-logged-in'}`} ref={zipTooltipRef}>
                <div className="zip-tooltip-container">
                
                {(isZipScreenEnable == true) && (
                    <>
                        <div className="zip-code-container" style={{marginBottom: (state.const_var.displayerrorMessage?.zipcode?.trim() !== '' ||  state.const_var.ziperrormsg?.trim() !== '' ) && '5px'}}>
                            <div>
                                <input
                                    onInput={(e) => {
                                        if (e.target.value.length > e.target.maxLength)
                                            e.target.value = e.target.value.slice(0, e.target.maxLength);
                                        }
                                    }
                                    className="posting_price_input"
            
                                    value={selectedZipCode}
                                    placeholder="XXXXX"
                                    onChange={(e) => handleZipCode(e)}
                                    maxLength={5}
                                />
                            </div>
                            {const_var.loginSession ? (
                                <>
                                    {state.const_var.zipCode?.length === 5 || state.const_var.state_mfg_zipcode.length === 5 ? (
                                        <div className="selected-state">
                                            {const_var.zipcodeToolTipDataFlag && Object.keys(const_var.zipcodeToolTipData).length > 0
                                                ? const_var.zipcodeToolTipData?.data[0]?.state_name
                                                : state.const_var.stateNameAcordingAPI[state.params.p_s_n]
                                            }
                                            {/* <i className="icon-arrow-down-ico"></i> */}
                                        </div>
                                    ) : (
                                        <div style={{ textAlign: "right" }}>
                                            {/* <i className="icon-locator-ico"></i> */}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    {state.const_var.zipCode?.length === 5 || state.const_var.state_mfg_zipcode.length === 5 ? (
                                        <div className="selected-state">
                                            {const_var.zipcodeToolTipDataFlag && Object.keys(const_var.zipcodeToolTipData).length > 0 && const_var.zipcodeToolTipData.status
                                                ? const_var.zipcodeToolTipData?.data[0]?.state_name
                                                : state.const_var.showStateBoxInZipErr
                                                    ? state.const_var.stateNameAcordingAPI[state.params.p_s_n]
                                                    : ""
                                            }
                                            {/* <i className="icon-arrow-down-ico"></i> */}
                                        </div>
                                    ) : (
                                        <div style={{ textAlign: "right" }}>
                                            {/* <i className="icon-locator-ico"></i> */}
                                        </div>
                                    )}
                                </>
                            )}

                        </div>
                                {state.const_var.displayerrorMessage != undefined && state.const_var.displayerrorMessage.zipcode != undefined && state.const_var.displayerrorMessage.zipcode != ''  ?
                                    <div className="errorMessageZipToolTip" id="zcodeErrorMessage">
                                        
                                        {state.const_var.displayerrorMessage.zipcode}
                                    </div>
                                    :
                                    <>
                                        {state.const_var.ziperrormsg != undefined && state.const_var.ziperrormsg != '' &&
                                            <div className="errorMessageZipToolTip" id="zcodeErrorMessage">

                                                {state.const_var.ziperrormsg}
                                            </div>
                                        }
                                    </>
                                }
                                { state.const_var.showStateZip == false && state.const_var.zipManufErrMsg != undefined && state.const_var.zipManufErrMsg != '' && state.const_var.loginSession == false &&
                                    <div className={state.const_var.zipErrorMsgFlag == true ? 'errorMessageZipExistToolTip' :  "errorMessageZipExistToolTip success"} id="zcodeErrorMessage">

                                        {state.const_var.zipManufErrMsg}
                                    </div>
                                } 
                    </>
                )}
                {/*  ############ User company selction component ############## : Start : */}
                    {
                            (state.const_var.isFromSalesLogin == true && state.const_var.loginSession == true && state.const_var.userCompanies && state.const_var.userCompanies.length > 1) &&

                            <div className="manufacturer-container state-container">
                                <div>Company :&nbsp;</div>
                                <ZipDropDown
                                    label="Company"
                                    value={state.params.company_id === "" ? 'Select' : state.params.company_id}
                                    onChange={(value) => {
                                        if(state.params.company_id != value) dispatch(handleCompanySelection(value, "tooltip"))}
                                    }
                                    options={[
                                        // { label: "Select", value: "Select" }, // Keep "Select" as the first option
                                        ...const_var.userCompanies
                                            ?.filter(val => val.company_name !== "Select").sort((a, b) => a.company_name.localeCompare(b.company_name))?.map((val) =>
                                            ({
                                                value: val.company_id,
                                                label: val.company_name
                                            }))
                                    ]}
                                />
                            </div>
                    }
                    {
                        state.const_var.displayerrorMessage.company_id != '' && <div className="errorMessageZipToolTip" id="zcodeErrorMessage">
                            {state.const_var.displayerrorMessage.company_id}
                        </div>  
                    }
                {/*  ############ User company selction component ############## : END : */}
                {!state.const_var.displayerrorMessage.company_id && (((isZipScreenEnable == false) ||
                    (state.const_var.is_State_Edit != undefined &&
                    state.const_var.is_State_Edit == true &&
                    state.const_var.editAPIDataByResponse.data != undefined &&
                    state.const_var.editAPIDataByResponse.data.created_at <= "2023-12-13") || (const_var.loginSession == true && !state.const_var.showStateBoxInZipErr))) 
                    && (
                    
                        <div className={isZipScreenEnable ? ((setZipCode!=undefined && setZipCode!="" && Object.keys(setZipCode).length >= 5) || ((setZipCode == undefined || setZipCode == '') && state.const_var.crmSetting.is_Edit == true && isZipScreenEnable == true)) ?`manufacturer-container ${showState && 'hide-state-label'}` :`manufacturer-container disabled`  :`manufacturer-container ${showState && 'hide-state-label'} ${state.const_var.is_loader && 'disabled'}`} style={{marginTop:"20px"}}>
                            <span className={(state.const_var.is_loader==true )?"active saving-effect saving-effect-type-2 disabled":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                            <div className="state-label">State :&nbsp;</div>
                            <ZipDropDown
                                label={'State'}
                                onChange={(value) => {
                                    setSelectedState(value)
                                    if(state.const_var.stateManufacturerAcordingAPI != undefined && state.const_var.stateManufacturerAcordingAPI[selectedState] != undefined && state.const_var.loginSession == true) {
                                    if(state.const_var.stateManufacturerAcordingAPI[value]!=undefined && state.const_var.stateManufacturerAcordingAPI[value].length>0){
                                        let manuData =  state.const_var.stateManufacturerAcordingAPI[value]?.map((val, index) => {
                                            return {
                                                value: val.id,
                                                label: val.name,
                                            };
                                        })
                            
                                        if(manuData != undefined && manuData.length > 0) {
                                            setSelectedManufacture(manuData[0].value)
                                        } else {
                                            setSelectedManufacture(state.params.m_s_n)
                                        }
                                    }
                                    }
                                }}
                                onShowState={(value) => setShowState(value)}
                                value={selectedState}
                                options={stateArr}
                            />
                            {/* <div className="manufacturer-name">
                                <Select
                                    onChange={(e) => {
                                        setSelectedState(e.target.value)
                                        // setStateSel(e.target.value, "state");
                                        if(state.const_var.stateManufacturerAcordingAPI != undefined && state.const_var.stateManufacturerAcordingAPI[selectedState] != undefined && state.const_var.loginSession == true) {

                                            let manuData =  state.const_var.stateManufacturerAcordingAPI[e.target.value]?.map((val, index) => {
                                                return {
                                                    value: val.id,
                                                    label: val.name,
                                                };
                                            })
                            
                                            if(manuData != undefined && manuData.length > 0) {
                                            setSelectedManufacture(manuData[0].value)
                                            } else {
                                            setSelectedManufacture(state.params.m_s_n)
                                            }
                                        }}
                                    }
                                        value={selectedState}
                                        style={{width: getSelectTempWidth(getSelectedStateLabel()) + 'px'}}
                                        id="threed_state_change"
                                        ripple="RipplePropF"
                                        defaultValue={{ label: "Select", value: "" }}
                                        options={stateArr}
                                    />
                                    <i className="icon-arrow-down-ico"></i>
                                </div> */}
                        </div>
                )}


                {!state.const_var.displayerrorMessage.company_id && showManufacturerFields &&
                    (
                    (state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n] != undefined &&
                    state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].length > 0)
                    || 
                    (state.const_var.stateManufacturerAcordingAPI[selectedState] != undefined &&
                    state.const_var.stateManufacturerAcordingAPI[selectedState].length > 0)
                    ) &&
                    state.const_var.loginSession == true && (
                    <div className={isZipScreenEnable ? ((setZipCode!=undefined && setZipCode!="" && Object.keys(setZipCode).length >= 5) || ((setZipCode == undefined || setZipCode == '') && state.const_var.crmSetting.is_Edit == true && isZipScreenEnable == true)) ?"manufacturer-container" :"manufacturer-container disabled ": `manufacturer-container ${state.const_var.is_loader && 'disabled'}`}>
                        <span className={(state.const_var.is_loader==true )?"active saving-effect saving-effect-type-2 disabled":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                        <div>Manufacturer :&nbsp;</div>
                        <ZipDropDown
                            label="Manufacturer"
                            value={selectedManufacture}
                            onChange={(value) => {
                                setSelectedManufacture(value)
                                // dispatch(handleStateManufactureChange("manufacture",e.target.value))
                            }}
                            options={manufactureDropdown}
                        />
                        {/* <div className="manufacturer-name">
                            <Select
                                // placeholder="Select"
                                value={selectedManufacture}
                                ripple="RipplePropF"
                                onChange={(e) => {
                                    setSelectedManufacture(e.target.value)
                                }}
                                style={{width: getSelectTempWidth(getSelectedManufacturerLabel()) + 'px'}}
                                options={manufactureDropdown}
                            />
                            <i className="icon-arrow-down-ico"></i>
                        </div> */}
                    </div>
                    )}
                    {
                        (state.const_var.loginSession == false && isUserData == false && state.const_var.crmSetting.is_loggedin == true) &&
                        <div className="sales-login">
                            Click here for &nbsp;
                            <span onClick={() =>salesLogin()}>{(state.const_var.crmSetting.parent_api_token=="Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei" || state.const_var.crmSetting.parent_api_token=="P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke")?"Dealer Login":"Sales Login"}</span>
                        </div>
                    }
                </div>
                <div className="zipCode-close" onMouseDown={() => {
                    zipToolTipClose()
                    setShowTooltip(!isShowZipTooltip);
                    if(const_var.crmSetting.is_Edit == false && const_var.isPublicEdit == false && const_var.isKLinkEnable == false && (const_var.crmSetting.is_CRM == false || const_var.crmSetting.is_CRM == undefined && const_var.companyIdSelectedFromStateScreen != state.params.company_id)) {
                        let element = document.getElementsByTagName('body')[0]
                        if(element && element.classList.contains('full-screen-overlay')){
                            element.classList.remove('full-screen-overlay')
                        }
                        dispatch(handleCompanySelection(const_var.companyIdSelectedFromStateScreen, 'tooltip'))

                    }
                }}>
                    <i className="icon-close" ></i>
                </div>
                <div
                    className={
                        const_var.loginSession
                        ? "zip-tooltip-footer"
                        : !const_var.loginSession &&
                        selectedZipCode.length == 5 && 
                        state.const_var.ziperrormsg == "" 
                        ? "zip-tooltip-footer"
                        : (!const_var.loginSession && !isZipScreenEnable )
                        ?"zip-tooltip-footer" : 
                        !const_var.loginSession &&
                            state.const_var.ziperrormsg !== "" &&
                            state.const_var.displayerrorMessage.zipcode !== ""
                        ? "zip-tooltip-footer d-none"
                        : "zip-tooltip-footer d-none"
                    }
                    >

                    <div className="footer-text">  
                        Switching the options will require you to start designing your building from the start, resetting your current design.
                    </div>

                    <div className= {isZipScreenEnable ? ((setZipCode!=undefined && setZipCode!="" && Object.keys(setZipCode).length >= 5) || ((setZipCode == undefined || setZipCode == '') && state.const_var.crmSetting.is_Edit == true && isZipScreenEnable == true)) ? "footer-btn" : "footer-btn disabled" : `footer-btn ${state.const_var.is_loader && 'disabled'}`}>
                            <button className="btn btn-primary" onMouseDown={() => confirmChange()}>
                                Ok
                            </button>
                    </div>
                </div>
            </div>
        }
        <div className="zicode-error-overlay"></div>
        </>
    );
};

export default ZipcodeTooltip;
